export function validateRatchetBracket(data) {
  if (data.mode === undefined || data.mode === '') {
    return [false, 'No mode selected.'];
  }
  if (data.mode === 'OCO_ANCHORED') {
    if (
      data.ocoStopPrice === undefined ||
      data.ocoStopPrice === null ||
      parseFloat(data.ocoStopPrice) <= 0 ||
      isNaN(data.ocoStopPrice)
    ) {
      return [false, 'Ratchet Bracket OCO stop price must be greater than zero.'];
    }
    if (
      data.ocoTargetPrice === undefined ||
      data.ocoTargetPrice === null ||
      parseFloat(data.ocoTargetPrice) <= 0 ||
      isNaN(data.ocoTargetPrice)
    ) {
      return [false, 'Ratchet Bracket OCO target price must be greater than zero.'];
    }
    if (Number(data.ocoStopPrice) === Number(data.ocoTargetPrice)) {
      return [false, 'Ratchet Bracket OCO stop and target prices must be different.'];
    }
    if (
      data.ocoNumberOfTargets === undefined ||
      data.ocoNumberOfTargets === null ||
      !Number.isInteger(Number(data.ocoNumberOfTargets)) ||
      Number(data.ocoNumberOfTargets) < 1
    ) {
      return [false, 'Ratchet Bracket number of targets must be an integer of at least 1.'];
    }
    if (
      data.qtyBasisValuePerBracket === undefined ||
      parseFloat(data.qtyBasisValuePerBracket) <= 0 ||
      isNaN(data.qtyBasisValuePerBracket)
    ) {
      if (data.qtyBasis === 'PERCENT' && Number(data.trailQtyBasisValue) === 1) {
        return [true, ''];
      }
      return [false, 'Ratchet Bracket quantity basis value per bracket must be greater than zero.'];
    }
    return [true, ''];
  }
  if (data.mode === 'EQUAL_INTERVAL') {
    if (
      data.targetPerBracket === undefined ||
      parseFloat(data.targetPerBracket) <= 0 ||
      isNaN(data.targetPerBracket)
    ) {
      return [
        false,
        'Ratchet Bracket target per bracket is equal to, or less than zero.',
      ];
    }
    if (
      data.stopPerBracket === undefined ||
      parseFloat(data.stopPerBracket) <= 0 ||
      isNaN(data.stopPerBracket)
    ) {
      return [
        false,
        'Ratchet Bracket stop per bracket is equal to or less than zero.',
      ];
    }
    if (
      data.qtyBasisValuePerBracket === undefined ||
      parseFloat(data.qtyBasisValuePerBracket) <= 0 ||
      isNaN(data.qtyBasisValuePerBracket)
    ) {
      if (data.qtyBasis === 'PERCENT' || data.qtyBasis === 'PROFIT') {
        if (data.trailQtyBasisValue !== 1) {
          return [
            false,
            'Ratchet Bracket quantity basis value per bracket is equal to, or less than zero and trail is not 100%.',
          ];
        }
      }
    }
  }
  return [true, ''];
}
